'use strict';

var IsIpfs = require('is-ipfs');

var promisify = require('promisify-es6');

var streamToValueWithTransformer = require('../utils/stream-to-value-with-transformer');

var moduleConfig = require('../utils/module-config');

var cleanCID = require('../utils/clean-cid');

module.exports = function (arg) {
  var send = moduleConfig(arg);
  var refs = promisify(function (args, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }

    opts = module.exports.normalizeOpts(opts);

    try {
      args = module.exports.checkArgs(args);
    } catch (err) {
      return callback(err);
    }

    var transform = function transform(res, cb) {
      cb(null, res.map(function (r) {
        return {
          ref: r.Ref,
          err: r.Err
        };
      }));
    };

    var request = {
      args: args,
      path: 'refs',
      qs: opts
    };
    send(request, function (err, result) {
      if (err) {
        return callback(err);
      }

      streamToValueWithTransformer(result, transform, callback);
    });
  });
  refs.local = require('./refs-local')(arg);
  refs.localReadableStream = require('./refs-local-readable-stream')(arg);
  refs.localPullStream = require('./refs-local-pull-stream')(arg);
  return refs;
};

module.exports.checkArgs = function (args) {
  var isArray = Array.isArray(args);
  args = isArray ? args : [args];
  var res = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var arg = _step.value;

      try {
        arg = cleanCID(arg);
      } catch (err) {
        if (!IsIpfs.ipfsPath(arg)) {
          throw err;
        }
      }

      res.push(arg);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return isArray ? res : res[0];
};

module.exports.normalizeOpts = function (opts) {
  opts = opts || {};

  if (typeof opts.maxDepth === 'number') {
    opts['max-depth'] = opts.maxDepth;
  }

  return opts;
};